export default __webpack_public_path__ + "static/media/fa-regular-400.73b22180.woff2";